import { useInfiniteQuery } from '@tanstack/react-query';
import { QueryKey } from '@/config/query-client';
import { getTimeInMs } from '@/helpers/get-time-in-ms';
import { fetchSharedProjects } from '@/api/v4/shared-projects';

export const useSharedProjects = (email: string | undefined) =>
  useInfiniteQuery({
    queryKey: [QueryKey.SharedProjects, email],
    queryFn: ({ pageParam = 1 }) => {
      if (!email) return [];
      return fetchSharedProjects({
        page: pageParam,
        items: 10,
        uid: email,
      });
    },
    initialPageParam: 1,
    staleTime: getTimeInMs(2, 'minute'),
    getNextPageParam: (lastPage, allPages) => {
      const nextPage = lastPage.length ? allPages.length + 1 : undefined;
      return nextPage;
    },
  });
